import { IIntakeIdWithDates } from 'api-paths-cas';
import { all, call, cancelled, fork, put, select, takeLatest, getContext } from 'redux-saga/effects';
import { getUniqueCount } from '../../../api/api';
import isTesting from '../../../utilities/isTesting';
import { logout } from '../../auth/actions';
import { AuthState } from '../../auth/types';
import { getAuth, getConfig, getIntakeId, getIntakeRange, getUI } from '../../selectors';
import { getSelectedPartnersFailure, getSelectedPartnersSuccess, getSelectedPartnersComplete } from '../actions';
import { DashboardActionTypes, ISelectedOption } from '../types';
import { createUniqueCountParams } from './helpers';

export let getSelectedPartnersAbortController: AbortController;

export function* handleGetSelectedPartnersTotals() {
  let res: ISelectedOption;
  const auth: AuthState = yield select(getAuth);
  const config = yield select(getConfig);
  const intakeId: string = yield select(getIntakeId);
  if (!intakeId && !isTesting) {
    return;
  }
  const { headerTab } = yield select(getUI);
  const intakeRange: IIntakeIdWithDates | undefined = yield select(getIntakeRange, intakeId!);
  const context = yield getContext('sagaContext');
  const idToken: any = yield call(context.getIdToken);

  try {
    if (!idToken) {
      yield put(logout());
      yield call(context.onLogout);
      console.log('Refresh Token has Expired - handleGetSelectedPartnersTotals');
      return;
    }
    const getSelectedPartnersParams = createUniqueCountParams({
      getUniqueCountAbortController: getSelectedPartnersAbortController,
      auth,
      config,
      intakeId,
      headerTab,
      intakeRange,
      idToken,
    });
    if (!getSelectedPartnersParams) {
      return;
    }

    getSelectedPartnersAbortController = new AbortController();
    res = yield call(getUniqueCount, 'partners', getSelectedPartnersParams);
  } catch {
    yield put(getSelectedPartnersFailure());
    return;
  } finally {
    if (yield cancelled()) {
      // the task was cancelled
      getSelectedPartnersAbortController.abort();
      return;
    }
  }
  yield put(getSelectedPartnersSuccess(res));

  yield put(getSelectedPartnersComplete());
}

function* watchGetSelectedPartners() {
  yield takeLatest(DashboardActionTypes.GET_SELECTED_PARTNERS, handleGetSelectedPartnersTotals);
}

function* GetSelectedPartnersSaga() {
  yield all([fork(watchGetSelectedPartners)]);
}

export default GetSelectedPartnersSaga;
